<template>
  <div class="login_wrap">
    <div class="login_content">
      <div class="content_left">
        <!-- <div class="title_one">欢迎登录</div> -->
        <div class="title_two">欢迎来到医知检PC端</div>
        <div class="title_three">请输入账号密码</div>
        <div class="title_three">进行登录</div>
        <div class="login_password">
          <el-form :model="param" :rules="rules" ref="login" label-width="0px" class="ms-content">
            <el-form-item prop="username" style="margin-bottom: 20px">
              <el-input v-model.trim="param.username" placeholder="输入账号">
                <template slot="prepend"> <i class="el-icon-user"></i> </template>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input :type="passwordType" placeholder="输入密码" v-model.trim="param.password"
                @keyup.enter.native="submitForm()">
                <template slot="prepend"> <i class="el-icon-goods"></i> </template>
                <i slot="suffix" v-if="passwordType !== 'password'" class="el-input__icon iconfont iconzhengyan"
                  style="cursor: pointer; font-size: 20px; color: #2d99d7" @click="showPwd"></i>
                <i slot="suffix" v-if="passwordType === 'password'" class="el-input__icon iconfont iconbiyan1"
                  style="cursor: pointer; font-size: 20px" @click="showPwd"></i>
              </el-input>
            </el-form-item>
          </el-form>
          <div class="password_bottom">
            <div class="password_title"><el-checkbox v-model="checked"></el-checkbox> 记住密码</div>
            <div class="password_title" @click="forgetPassword">忘记密码?</div>
          </div>
          <div class="bottom_btn">
            <el-button type="primary" @click="submitForm">登录</el-button>
          </div>
        </div>
      </div>
      <div class="content_right"></div>
    </div>
    <ul class="bg-bubbles">
      <li v-for="i in 10" :key="i"></li>
    </ul>
    <el-dialog width="40%" :visible.sync="dialogVisible">
      <template slot="title">
        <div class="patient_dialogheader">
          <div class="dialog_title">检测到你账号 <span style="color:red;">【{{ param.username ? param.username : "" }}】</span>
            下关联多家账户，请选择你本次需要修改的账户；</div>
          <!-- <div class="dialog_search">
          <el-input
            v-model.trim="dialogInputName"
            placeholder="请输入患者姓名"
            clearable
            @clear="getSearchList"
            style="width: 300px; margin-right: 20px"
          ></el-input>
          <el-button type="primary" plain style="width: 70px" @click="getSearchList">查询</el-button>
        </div> -->
        </div>
      </template>
      <div class="dialogTable" style="height: calc(100vh - 380px)">
        <el-table :data="accountData" border :header-cell-style="{ backgroundColor: '#F3F4F7' }" height="100%"
          style="width: 100%" highlight-current-row>
          <el-table-column type="index" width="50" align="center"></el-table-column>
          <el-table-column prop="calCode" width="100" label="编码" align="center"></el-table-column>
          <el-table-column prop="calName" label="名称" align="center"></el-table-column>
          <el-table-column prop="sysusername" width="100" label="负责人" align="center"></el-table-column>
          <el-table-column prop="operatoridentity" width="100" label="角色" align="center">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.operatoridentity=='admin'">管理员</el-tag>
              <el-tag type="warning" v-else-if="scope.row.operatoridentity=='D'">医生</el-tag>
              <el-tag type="info" v-else-if="scope.row.operatoridentity=='D'">其他</el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="cml_mobile_phone" label="电话" align="center"></el-table-column> -->
          <el-table-column label="操作" align="center" fixed="right" width="100">
            <template slot-scope="scope">
              <span style="font-size: 13px; color: #36b6ff; cursor: pointer" @click.stop="clickRow(scope.row)">
                选择
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import request from '@/utils/request';
import { async } from 'q';
export default {
  name: 'Login',
  data: function () {
    return {
      checked: false,
      passwordType: 'password',
      dialogVisible: false,
      accountData: [],
      param: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    };
  },
  mounted() {},
  methods: {
    checkHH(){
      const passwordreg = /^(?=.{8})(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[_.\-#$%!@]).*$/;
      const isValid = passwordreg.test(this.param.username);
      // console.log(this.param.username,":xx:",isValid)
    },
    // 获取当前账户下诊所列表
    getAllClinicList() {
      const that = this;
      let params = {
        sysuser: that.param.username,
        syspassnew: that.param.password
      };    
      request
        .post('/login/listCalCodeByChannelAccount', params, {category: 'XuXiZhi'})
        .then((res) => {
          // console.log("列表返回值：", res)
          if (res.success) {
            if (res.data.length === 1) {
              // console.log("只有一个列表");
              this.$confirm('尊敬的用户: 经安全检测你的登录密码初始化之后还未修改过，请前往修改后重新登录；', '安全提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                showCancelButton:false,
                showClose: false,
                type: 'warning',
                center: true
              }).then(() => {
                // this.$router.push('/checkPassword');
                that.$router.push({ path: '/checkPassword', query: res.data[0] });
              }).catch(() => {
               this.$message({
                type: 'info',
                message: '已取消'
                });          
              });
            } else if (res.data.length > 1) {
              that.accountData = res.data;
              that.dialogVisible = true;
            } else {
              that.$message.error('抱歉，查询账号列表出错0');
            }
          } else {
            that.$message.error('抱歉，查询账号列表出错1');
          }
        })
    },
    clickRow(row) {
      this.$router.push({ path: '/checkPassword', query: row });
      // that.$router.push('/checkPassword');
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }
    },
    remberPassword(val) {
      // console.log(val);
    },
    forgetPassword() {
      this.$router.push('/resetPassword');
    },
    submitForm() {
      const that = this;
      this.$refs.login.validate((valid) => {
        if (valid) {
          const param = {
             loginChannel: 'whale',
             loginType: 'account',
             validHours:'24',
             loginId: that.param.username,
             loginPass: that.param.password
          }
         
          request.get(`/login/index?loginChannel=whale&loginType=account&validHours=24&loginId=${that.param.username}&loginPass=${that.param.password}`,{category:'XuXiZhi'})
          .then( async (res)=>{
            console.log('login 返回：',res)
           
            if(res.success && res.data && res.data.token){
                const data = res.data.channelLoginfoList[0]
                const userData = {
                  "token": data.token,
                  "userid": data.userid,
                  "hsp_name": data.hspName,
                  "hsp_code": data.hspCode,
                  "sysuser": data.sysuser,
                  "sysusername": data.sysusername,
                  "pal_code": data.palCode,
                  "pal_name": data.palName,
                  "cal_code": data.calCode,
                  "cal_name": data.calName,
                  "caa_Picture_address": data.caaPictureAddress,
                  "Operatoridentity": data.operatoridentity,
                  "usertype": data.usertype
                }
                console.log('user:',userData)
                // this.$message.success('登录成功');
                localStorage.setItem('ms_username', this.param.username);
                sessionStorage.setItem('user', JSON.stringify(userData));
                localStorage.setItem('chooseProduct', JSON.stringify([]));
                localStorage.removeItem('chooseSyf'); //干掉收样方缓存              
                // that.$router.push('/dashboard');
                await that.judgeFirstLogin(res.data.channelLoginfoList[0].userid, res.data.token); //判断知否第一次登录 
            }else {
                this.$message.error('帐号或密码有误！');
              }
          })
          //孙总登录接口20251115
          //   const params = {
          //   sysuser: that.param.username,
          //   syspass: that.param.password
          // };
          // request
          //   .post('/server/Channelloginfo.php', params)
          //   .then(async (res) => {
          //     // console.log('login_success:', res);
          //     if (res.token) {
          //       // this.$message.success('登录成功');
          //       localStorage.setItem('ms_username', this.param.username);
          //       sessionStorage.setItem('user', JSON.stringify(res));
          //       localStorage.setItem('chooseProduct', JSON.stringify([]));
          //       localStorage.removeItem('chooseSyf'); //干掉收样方缓存              
          //       await that.judgeFirstLogin(res.userid, res.token); //判断知否第一次登录               
          //     } else {
          //       this.$message.error('帐号或密码有误！');
          //     }
          //   })
          //   .catch((err) => {
          //     this.$message.error('抱歉，网络出错，请联系管理员');
          //     // console.log('login_err:', err);
          //   });
        } else {
          this.$message.error('请输入账号和密码');
          // console.log('error submit!!');
          return false;
        }
      });
    },
    // 判断是否第一次登录如果是第一次登录强制修改密码
    async judgeFirstLogin(id, token) {
      const that = this;
      let dataP = {
        dqppid: id
      };
      const params = {
        token: token,
        workid: 'f518b51a-2ea8-94f5-bdb3-66be044f1082',
        data: JSON.stringify(dataP)
      };
      await request
        .post('/server/getdatalisapi.php', params)
        .then((res) => {
          // that.getAllClinicList();
          // console.log("第一次登录返回值：：", res)
          if (res.length) {
            if (res[0].Change_password_the_first === '是') {
              // console.log("登录成功 已经修改")
              that.$message.success('登录成功')
              that.$router.push('/dashboard');
            } else {
              // console.log("第一次登录 强制修改密码")
              that.getAllClinicList();
            }
          } else {
            that.$message.error('抱歉，判断是否第一次登录失败，请联系管理员；');
          }
        })
    }
  },
};
</script>

<style lang="scss" scoped>
.dialog_title {
  color: orange;
  text-align: center;
}

.login_wrap {
  position: relative;
  // background: #b0e2fe;
  background: linear-gradient(0deg, #36c6ff, #c2e5f8);
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  // border: 1px solid red;
  display: flex;
  justify-content: center;
  align-items: center;

  //气泡样式开始
  .bg-bubbles {
    position: absolute;
    // 使气泡背景充满整个屏幕；
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    // 如果元素内容超出给定的宽度和高度，overflow 属性可以确定是否显示滚动条等行为；
    overflow: hidden;

    li {
      position: absolute;
      // bottom 的设置是为了营造出气泡从页面底部冒出的效果；
      bottom: -160px;
      // 默认的气泡大小；
      width: 40px;
      height: 40px;
      background-color: rgba(255, 255, 255, 0.15);
      list-style: none;
      // 使用自定义动画使气泡渐现、上升和翻滚；
      animation: square 15s infinite;
      transition-timing-function: linear;

      // 分别设置每个气泡不同的位置、大小、透明度和速度，以显得有层次感；
      &:nth-child(1) {
        left: 5%;
      }

      &:nth-child(2) {
        left: 20%;
        width: 90px;
        height: 90px;
        animation-delay: 2s;
        animation-duration: 7s;
      }

      &:nth-child(3) {
        left: 25%;
        animation-delay: 4s;
        // background-color: red;
      }

      &:nth-child(4) {
        left: 40%;
        width: 60px;
        height: 60px;
        animation-duration: 8s;
        background-color: rgba(255, 255, 255, 0.15);
      }

      &:nth-child(5) {
        left: 70%;
      }

      &:nth-child(6) {
        left: 80%;
        width: 120px;
        height: 120px;
        animation-delay: 3s;
      }

      &:nth-child(7) {
        left: 12%;
        width: 160px;
        height: 160px;
        animation-delay: 2s;
        background-color: rgba(255, 255, 255, 0.15);
      }

      &:nth-child(8) {
        left: 55%;
        width: 20px;
        height: 20px;
        animation-delay: 4s;
        animation-duration: 15s;
      }

      &:nth-child(9) {
        left: 25%;
        width: 10px;
        height: 10px;
        animation-delay: 2s;
        animation-duration: 12s;
        background-color: rgba(255, 255, 255, 0.3);
      }

      &:nth-child(10) {
        left: 85%;
        width: 160px;
        height: 160px;
        animation-delay: 5s;
      }
    }

    // 自定义 square 动画；
    @keyframes square {
      0% {
        opacity: 0.5;
        transform: translateY(0px) rotate(45deg);
      }

      25% {
        opacity: 0.75;
        transform: translateY(-400px) rotate(90deg);
      }

      50% {
        opacity: 1;
        transform: translateY(-600px) rotate(135deg);
      }

      100% {
        opacity: 0;
        transform: translateY(-1000px) rotate(180deg);
      }
    }
  }

  // 气泡样式结束
  .login_content {
    width: 850px;
    height: 500px;
    background: #ffffff;
    box-shadow: 0px 15px 50px 0px rgba(186, 186, 186, 0.5);
    border-radius: 35px;
    display: flex;
    justify-content: flex-start;
    overflow: hidden;
    z-index: 1000;

    .content_left {
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      padding: 50px;

      .title_one {
        font-size: 32px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #2d99d7;
        line-height: 49px;
        margin-bottom: 20px;
      }

      .title_two {
        font-size: 32px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #2d99d7;
        line-height: 49px;
        margin-bottom: 20px;
      }

      .title_three {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #203052;
      }

      .login_password {
        margin-top: 20px;
        width: 350px;
        height: 130px;

        // border: 1px solid red;
        ::v-deep .el-input-group__prepend {
          font-size: 16px !important;
        }

        ::v-deep .el-input-group {
          height: 45px !important;
        }

        ::v-deep .el-input--small .el-input__inner {
          height: 45px !important;
          line-height: 45px !important;
          border-radius: 0 10px 10px 0;
        }

        ::v-deep .el-input-group__prepend {
          background-color: #fbfdff;
          border-top: 1px solid #e7ecef;
          border-left: 1px solid #e7ecef;
          border-bottom: 1px solid #e7ecef;
          border-radius: 10px 0 0 10px;
        }

        ::v-deep .el-input__suffix {
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      .password_bottom {
        display: flex;
        justify-content: space-between;

        .password_title {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #2d99d7;
          // line-height: 49px;
          cursor: pointer;
        }

        ::v-deep .el-radio__inner {
          border-radius: 10% !important;
        }
      }

      .bottom_btn {
        margin-top: 40px;
        display: flex;
        justify-content: center;

        ::v-deep .el-button--small {
          padding: 13px 16px !important;
          width: 300px !important;
          font-size: 12px !important;
          border-radius: 16px !important;
        }
      }
    }

    .content_right {
      flex: 1;
      // border: 1px solid rgb(81, 238, 9);
      background: url(../../assets/img/login-back.png) no-repeat center center;
      background-size: cover;
    }
  }
}
</style>
